<template>
  <v-col cols="12">
    <div v-if="!loading">
      <div v-if="charts.labels.length">
        <h2>{{ device.name }} :</h2>
        <Line2
            style="max-height: 50em"
            :options="chartOptions"
            :data="charts"
        />
        <v-divider class="my-10"></v-divider>
      </div>
    </div>
    <v-col v-else cols="12" class="text-center">
      <v-progress-circular
          :size="50"
          :width="7"
          color="#d20003"
          indeterminate
      ></v-progress-circular>
    </v-col>
  </v-col>
</template>

<script>
import axios from "axios";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line as Line2 } from "vue-chartjs";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

export default {
  name: "BoardReport",
  props: {
    device: {type: Object, required: true},
    board_id: {type: [String, Number], required: true},
    date_range: {type: String, required: true},
    set: {type: Array, default: () => []}
  },
  components: {Line2},

  data: () => ({
    loading: false,
    charts: {
      labels: [],
      datasets: [{
        fill: 'start',
      }]
    },
    chartOptions: {
      interaction: {
        intersect: false,
      },
      elements: {
        line: {
          tension: 0.4,
          borderWidth: 2,
          fill: 'start'
        },
        point: {
          radius: 0,
          hoverRadius: 0,
          borderWidth: 0,
          hoverBorderWidth: 0
        }
      },
    }
  }),



  computed: {
    authHeaders() {
      return {Authorization: `Token ${localStorage.getItem("key")}`};
    }
  },

  watch: {
    date_range: {
      immediate: true,
      handler: "fetchData"
    },
    'device.value': {
      handler: "fetchData"
    }
  },

  methods: {
    async fetchData() {
      const requestParams = {
        device: "S",
        pk: this.board_id,
        field_name: this.device.value,
        start: this.date_range
      };
      try {
        this.loading = true;
        const {data} = await axios.get(
            `${this.BACKEND_LINK}/api/devices-data/device/`, {
              params: requestParams,
              headers: this.authHeaders
            }
        );

        this.charts = this.transformChartData(data);
      } catch (error) {
        this.handleError(error);
      } finally {
        this.loading = false;
      }
    },

    transformChartData(responseData) {
      let datasets = [{
        label: this.device.name,
        borderColor: "#D20003",
        fill: 'origin',
        backgroundColor: "#D20003",
        data: responseData.map(item => item._value)
      }]
      if(this.set){
        datasets.push({
          label: 'ست پوینت',
          borderColor: "#0bff00",
          fill: 'origin',
          data: responseData.map(
              ()=>parseInt(this.set.value)
          )
        });
      }
      return {
        labels: responseData.map(item => this.formatDate(item._time)),
        datasets: datasets
      };
    },

    formatDate(isoString) {
      const date = new Date(isoString);
      const timePart = date.toLocaleString("fa-ir").split(",")[1]?.trim();
      const datePart = date.toLocaleString("fa-ir").split(",")[0]?.trim();
      return `${timePart} ${datePart}`;
    },

    handleError(error) {
      const statusCode = error.response?.status;
      this.$snotify.error("خطا در دریافت اطلاعات", `کد ${statusCode}`);
    }
  },
};
</script>